export const mapRoot = '/karte';
